import React, { useEffect, useState } from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import banner from "../../Assets/Service/itsolutionBanner.png";
import ItSolutionDetails from '../../components/User/Service/ItSolutionDetails';
import { useParams } from 'react-router-dom';
import itServices from "../../config/itServices.json"

const ItSolution = () => {

  const { id } = useParams()
  const [service, setService] = useState(null)

  useEffect(() => {
    const foundService = itServices.find(serv => serv.id === id)
    setService(foundService)
  }, [id])

  return (
    <div className='overflow-hidden'>
      <CommonBanner backgroundImage={banner} title={service?.servieName} subheading="Home/IT Solution" />
      <ItSolutionDetails service={service} />
    </div>
  )
}

export default ItSolution